import { useState } from 'react';
import { X, Lock } from 'lucide-react';
import PINKeyboard from './PINKeyboard';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PINModal({ playlistName, onClose, onSuccess }) {
  const [pin, setPin] = useState('');
  const [verifying, setVerifying] = useState(false);

  const handleNumberClick = (num) => {
    if (pin.length < 4) {
      const newPin = pin + num;
      setPin(newPin);
      
      // Auto-verify when 4 digits entered
      if (newPin.length === 4) {
        verifyPIN(newPin);
      }
    }
  };

  const handleBackspace = () => {
    setPin(pin.slice(0, -1));
  };

  const handleClear = () => {
    setPin('');
  };

  const verifyPIN = async (pinToVerify) => {
    setVerifying(true);
    try {
      const response = await axios.post(`${API}/settings/verify-explicit-pin`, {
        pin: pinToVerify
      });

      if (response.data.valid) {
        toast.success('Access granted!');
        onSuccess();
      } else {
        toast.error('Incorrect PIN');
        setPin('');
      }
    } catch (error) {
      console.error('Error verifying PIN:', error);
      toast.error('Failed to verify PIN');
      setPin('');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
      <div className="glass-card max-w-sm w-full p-4 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-white/70 hover:text-white"
        >
          <X size={20} />
        </button>

        <div className="flex flex-col items-center mb-4">
          <div className="bg-red-500/20 p-2 rounded-full mb-2">
            <Lock size={24} className="text-red-500" />
          </div>
          <h2 className="text-xl font-bold mb-1">Explicit Content</h2>
          <p className="text-center text-white/70 text-sm mb-1">{playlistName}</p>
          <p className="text-xs text-white/50">Enter 4-digit PIN</p>
        </div>

        {/* PIN Display */}
        <div className="flex justify-center gap-2 mb-4">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`w-10 h-10 rounded-lg border-2 flex items-center justify-center text-xl font-bold ${
                pin.length > i
                  ? 'border-red-500 bg-red-500/20'
                  : 'border-white/30 bg-white/5'
              }`}
            >
              {pin.length > i ? '•' : ''}
            </div>
          ))}
        </div>

        {/* Custom Keyboard */}
        <PINKeyboard
          onNumberClick={handleNumberClick}
          onBackspace={handleBackspace}
          onClear={handleClear}
        />

        {verifying && (
          <p className="text-center mt-2 text-white/50 text-xs">Verifying...</p>
        )}
      </div>
    </div>
  );
}
